module.exports = __webpack_public_path__ + "static/img/ZZtu3@2x.39c6b228.png";